/**
 * Small helpers shared by Regta's block compilers.
 *
 * Everything here is about ONE thing: turning "what did the user choose"
 * into "what does the document say". No rendering, no layout.
 */
/**
 * The blank-form rule: a printable empty form shows every alternative
 * unticked, so the reader can fill it in by hand. `cond` collapses the
 * mode check that used to sit at every branch in the React templates.
 */
export const cond = (mode, value) => (mode === 'blank' ? false : value);
export const arr = (value) => Array.isArray(value) ? value.filter((v) => typeof v === 'string') : [];
export const str = (value) => {
    if (typeof value !== 'string')
        return null;
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
};
export const rows = (value) => Array.isArray(value) ? value.filter((r) => typeof r === 'object' && r !== null) : [];
export const printLabel = (option) => option.renderLabel ?? option.label;
/** Projects document options into the slot vocabulary a host renders. */
export const slotOptions = (options) => options.map((o) => ({
    code: o.code,
    label: o.label,
    summary: o.summary,
    ...(o.value !== undefined && o.value !== o.code ? { value: o.value } : {}),
}));
export const multiSelectSlot = (key, label, options, extra = {}) => ({ key, label, type: 'multi_select', options: slotOptions(options), ...extra });
//# sourceMappingURL=lib.js.map